'use client';

import { CheckSquareIcon } from '@/shared';

import type { ILearnResult } from '../../types';

export const LearnResult = ({ items }: { items: ILearnResult['items'] }) => {
	return (
		<>
			<div className="-m-3 flex snap-x snap-mandatory flex-nowrap gap-4 overflow-x-auto p-3 xl:m-0 xl:grid xl:snap-none xl:grid-cols-3 xl:gap-4 xl:overflow-visible xl:p-0">
				{items.map((content, key) => (
					<dl
						key={key}
						className="flex w-10/12 shrink-0 snap-center flex-row gap-4 rounded-2xl border border-[#DBDFE9] bg-white p-4 max-xl:max-w-md xl:w-auto xl:gap-6 xl:rounded-3xl xl:p-6 2xl:gap-8 2xl:rounded-[40px] 2xl:p-8"
					>
						<dt>
							<CheckSquareIcon className="size-8" />
						</dt>
						<dd className="text-sm/[1.2] font-semibold text-[#252F4A] xl:text-base/[1.2] 2xl:text-2xl/[1.3]">
							{content}
						</dd>
					</dl>
				))}
			</div>
		</>
	);
};
